import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
/** Bytes por evento: attackerId(4) + targetId(4) + damage(2) + flags(1). */
export const COMBAT_EVENT_SIZE = 11;
/** Bit 0 de `flags`: o golpe matou o alvo. */
export const COMBAT_FLAG_KILLED = 1 << 0;
/** Bit 1 de `flags`: o golpe errou; `damage` vem zerado. */
export const COMBAT_FLAG_MISSED = 1 << 1;
export function encodeCombat(packet, writer = new BinaryWriter(4 + packet.events.length * COMBAT_EVENT_SIZE)) {
    writer.u8(ServerOp.Combat).u16(packet.events.length);
    for (const event of packet.events) {
        let flags = 0;
        if (event.killed)
            flags |= COMBAT_FLAG_KILLED;
        if (event.missed)
            flags |= COMBAT_FLAG_MISSED;
        writer.u32(event.attackerId).u32(event.targetId).u16(event.damage).u8(flags);
    }
    return writer;
}
export function decodeCombat(reader) {
    const count = reader.u16();
    const events = new Array(count);
    for (let i = 0; i < count; i++) {
        const attackerId = reader.u32();
        const targetId = reader.u32();
        const damage = reader.u16();
        const flags = reader.u8();
        events[i] = {
            attackerId,
            targetId,
            damage,
            killed: (flags & COMBAT_FLAG_KILLED) !== 0,
            missed: (flags & COMBAT_FLAG_MISSED) !== 0,
        };
    }
    return { events };
}
//# sourceMappingURL=combat.js.map